export const SET_SKIN = "SET_SKIN"
export const UPDATE_SKIN = "UPDATE_SKIN"

export const SET_CONTACT = 'SET_CONTACT'
export const UPDATE_CONTACT = "UPDATE_CONTACT"

export const SET_EDUCATION = 'SET_EDUCATION'
export const UPDATE_EDUCATION = 'UPDATE_EDUCATION'

export const SIGN_IN ="SIGN_IN";
export const SIGN_IN_FAILED ="SIGN_IN_FAILED";
export const SIGN_IN_SUCCESS ="SIGN_IN_SUCCESS";
export const SIGN_IN_REQUEST ="SIGN_REQUEST";
 
export const REGISTER ="REGISTER";
export const REGISTER_FAILED ="REGISTER_FAILED";
export const REGISTER_SUCCESS ="REGISTER_SUCCESS";
export const REGISTER_REQUEST ="REGISTER_REQUEST";

export const SIGN_OUT ="SIGN_OUT";
export const SIGN_OUT_FAILED ="SIGN_OUT_FAILED";
export const SIGN_OUT_SUCCESS ="SIGN_OUT_SUCCESS";
export const SIGN_OUT_REQUEST ="SIGN_OUT_REQUEST";

export const REMOVE_ERROR = "REMOVE_ERROR"